/**
 * Opens the shared upgrade modal and sends the plan the user picks to Stripe
 * checkout. Every way into the modal goes through here.
 */
angular.module('dentalLinksServices')

.factory('UpgradeModal', ['$uibModal', 'ModalHandler', 'Subscription', 'SubscriptionHelper', 'Notification', 'Logger',
    function ($uibModal, ModalHandler, Subscription, SubscriptionHelper, Notification, Logger) {
        return {
            // context: {status, feature, source}, all optional. `status` is the
            // practice's subscription status, if the caller has it; the modal fetches
            // what it needs without it. `feature` is the PREMIUM_FEATURES key of the
            // gate that was hit, `source` the entry point for DCL-532.
            open: function (context) {
                context = context || {};

                var modalInstance = $uibModal.open({
                    templateUrl: 'partials/upgrade_modal.html',
                    controller: 'UpgradeModalController',
                    resolve: {
                        currentStatus: function () { return context.status || null; },
                        feature: function () { return context.feature || null; },
                        source: function () { return context.source || null; }
                    }
                });

                ModalHandler.set(modalInstance);

                modalInstance.result.then(function (selectedInterval) {
                    SubscriptionHelper.redirectToCheckout(Subscription, selectedInterval, function (error) {
                        Notification.error('Unable to start checkout. Please try again.');
                        Logger.log('Checkout error from the upgrade modal: ' + JSON.stringify(error));
                    });
                });
            }
        };
    }]);
